import { createSelector } from '@reduxjs/toolkit';
import { selectBuildingGatesType } from 'shared/selectors/jsonQuery';
import { EBuildingGatesType } from '../../../../packages/api-models/common/json_query';

const OPTIONS = [
  { label: 'Докового типа', value: EBuildingGatesType.Dock },
  { label: 'На нулевой отметке', value: EBuildingGatesType.Ground },
  { label: 'На пандусе', value: EBuildingGatesType.Ramp },
];

export const selectBuildingGatesTypeFilter = createSelector(selectBuildingGatesType, value => ({
  label: 'Ворота',
  options: OPTIONS,
  value: value && value.length > 0 ? value : [null],
}));
